import React from 'react';
// import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';
import './index.scss';
import { videoWatch } from '@/services/api';
import { isLogged, trackClickByActivity } from '@/utils/util';
import emitter from '@/utils/events';
class VideoItem extends React.Component {
  state = {
    playing: false,
    isWatchedVideo: false,
    enableWatchVideo: false
  }
  constructor(props) {
    super(props)
    this._video = null;
    this.pause = this.pause.bind(this);
    this.resume = this.resume.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
  }
  componentDidMount() {
    this.eventEmitter = emitter.addListener('WatchedVideoForChance', ({isWatchedVideo, enableWatchVideo})=>{
console.log('emitter', isWatchedVideo)
      this.setState({isWatchedVideo, enableWatchVideo})
    });
    let _self = this;
    // this._video = videojs('video', {}, function () {
    //   this.on('play', function () {
    //     _self.setState({
    //       playing: true,
    //     });
    //   });
    //   this.on('pause', function () {
    //     _self.setState({
    //       playing: false,
    //     });
    //   });

    //   this.on('ended', function () {
    //     _self.setState({
    //       playing: false,
    //     }, async()=> await videoWatch());

    //   });
    // });
    this._video = document.getElementById("video");
    this._video.onplay = () => {
      _self.setState({
        playing: true,
      }, async () => await this.getWatchVideoChance());
    };

    this._video.onpause=()=>{
      _self.setState({
        playing: false,
      });
    };

    this._video.onended = () => {
      _self.setState({
        playing: false,
      });
    };

    document.addEventListener('visibilitychange', this.onVisibilityChange, false)
    document.addEventListener('resume', this.resume, false)
    document.addEventListener('pause', this.pause, false)
  }

  
  pause = () => {
    this._video && this._video.pause()
  }

  onVisibilityChange = async () => {
    if (document.hidden) {
      this._video && this._video.pause()
    }
  }

  play = () => {
    trackClickByActivity('20190903_3');
    this._video && this._video.play();
  }

  getWatchVideoChance= async()=>{
    const {isWatchedVideo, enableWatchVideo} = this.state;
    if(!enableWatchVideo) return;
    if(isWatchedVideo) return;
    await videoWatch();
    emitter.emit('fetchDrawInfo', '');
  }
  toggle = async () => {
    if (this._video) {
      const token = await isLogged() 
      if (!token) {
        window.crgt.router.openLogin().then((res) => {
          if (res && res.code === 0) {
            window.location.reload();
          }
        });
      } else {
        this._video.paused ? this.play() : this.pause();
      }
    }
  }
  resume = async () => {
    this._video && this._video.pause()
  }

  componentWillUnmount() {
    emitter.removeListener(this.eventEmitter);
    // 移除事件绑定
    document.removeEventListener('pause', this.pause, false);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    document.removeEventListener('resume', this.resume);
    // destroy player on unmount
    if (this._video) {
      this._video.dispose()
    }
  }

  renderVideo() {
    const { posterUrl, videoUrl } = this.props;
    return (<video
      id="video"
      key={videoUrl}
      x5-playsinline="false"
      webkit-playsinline="true"
      x-webkit-airplay="true"
      playsInline={true}
      className="video video-js vjs-default-skin"
      style={{ objectFit: 'fill' }}
      poster={posterUrl}
      preload="true"
    >
      <source src={videoUrl} type="video/mp4" />
    </video>)
  }
  render() {
    const { playing } = this.state;
    const { playImgUrl = "https://static.ccrgt.com/images/c46eee31-2116-4507-a44e-f033d7d395c5.png", videoBg, style } = this.props;
    return (
      <div className="video-container" style={{ ...style, backgroundImage: `url(${videoBg})` }}>
        <div className="video-content">
          {this.renderVideo()}
          <div className="video-mask" onClick={this.toggle}><img
            src={playImgUrl}
            className={`play-img ${playing ? 'hide' : ''}`}
          /></div>
        </div>
      </div>
    );
  }
}

export default VideoItem;